<template>
	
	<div class="user-container" ref="content">
		
				<div class="main clearfix">
					<div class="tabBarWrap  lt pc-element">
							<div class="tabBar ">
								<div :class="['tabSel', $route.name === 'message' ? 'on' : '']" @click="$router.push('/we')">Message</div>
								<div :class="['tabSel', $route.name === 'order' ? 'on' : '']" @click="$router.push('/order')">Order</div>
								<div :class="['tabSel', $route.name === 'modifyInfo' ? 'on' : '']" @click="$router.push('/modifyInfo')">User</div>
								<div :class="['tabSel', $route.name === 'receive' ? 'on' : '']" @click="$router.push('/receivelist')">Address</div>
								
							</div>
					</div>

					<div class="web-element">
							<van-tabs  scrollspy sticky  @click="tabClick" color="#90c31f" >
								<van-tab  :title='"Message"'   :key="'0'" ></van-tab>
								<van-tab  :title='"Order"'   :key="'1'" ></van-tab>
								<van-tab  :title='"User"'   :key="'2'" ></van-tab> 
								<van-tab  :title='"Address"'   :key="'3'" ></van-tab> 
							</van-tabs>
					</div>


					<div class="content rt" >
						
							<router-view />
						
					</div>
				</div>
      
	</div>

</template>

<script>
	export default {
		name: "we",
		data() {
			return {
				
			}
		},
		watch:{
		  $route(to,from){
			  	this.$nextTick(function(){
			  		  this.$refs.content.scrollTop = 0
			  	})
		  }
		},
		mounted() {

		},
		methods: {
			tabClick(e){
              if(e==0){
              	this.$router.push('/we')
              }
              if(e==1){
              	this.$router.push('/order')
              }
              if(e==2){
              	this.$router.push('/modifyInfo')
              }
              if(e==3){
              	this.$router.push('/receivelist')
              }
			}
		}

	}
</script>

<style lang="less">
	.user-container {
		margin-top:96px;
		overflow: auto;
    
		.main {
			width: 920px;
			height:100%;
			margin: 0 auto;
			.content {
				  min-height:calc(100vh - 96px);
					padding-left:50px;
					width: 82.6%;
					border-left: 1px solid #dcdddd;
					box-sizing: border-box;
				.head {
					padding: 37px 0;
					text-align: center;
					font-size: 20px;
					line-height: 50px;
					font-weight: bold;
				}
			}
			.tabBarWrap {
				width: 17.4%;
				padding-top: 92px;
				box-sizing: border-box;
			}
			.tabBar {
				width: 100%;
				>div {
					cursor: pointer;
				}
				.tabSel {
					padding: 12px 0;
					font-size: 18px;
					line-height: 50px;
					font-weight: bold;

					a {
						display: block;
					}
				}
				.tabSel:hover,
				.on {
					color: #90c31f;
				}
			}
		}
	}


	.user-container {

		.form {
			padding-left: 0px;
			.form-item {
				margin-bottom: 30px;
			}
			.form-label {
				width: 110px;
				height: 40px;
				padding-right: 20px;
				box-sizing: border-box;
				font-size: 16px;
				text-align: right;
				line-height: 40px;
				display: block;
			}
			.form-inline {
				display: inline-block;
			}

			.input-inline {
				width: 176px;
				margin-right: 15px;
				float: left;
			}

			.input-block {
				width: 100%;
				line-height:40px;
				padding-left: 110px;
				box-sizing: border-box;
			}

			.form-unselect {
				position: relative;
			}

			.input {
				width: 100%;
				box-sizing: border-box;
				padding:0 20px;
				border: 1px solid #DCDFE6;
				border-radius: 6px;
				font-size: 14px;
				color: #333;
				height:40px;
				line-height: 40px;
				background-color: #fff;
				display: block;
			}

			.select {
				padding-right: 30px;
				cursor: pointer;
			}

			.edge {
				position: absolute;
				right: 10px;
				top: 50%;
				margin-top: -8px;
				color: #999;
				transition: all .3s;
				cursor: pointer;
			}

			.edge::before {
				content: '\e600';
			}

			.select-group {
				z-index: 899;
				position: absolute;
				left: 0;
				top: 55px;
				padding: 5px 0;
				min-width: 100%;
				border: 1px solid #d2d2d2;
				max-height: 300px;
				overflow-y: auto;
				background-color: #fff;
				border-radius: 2px;
				box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
				box-sizing: border-box;
				display: none;

				.select-tips {
					padding-left: 23px;
					font-size: 14px;
					line-height: 36px;
					cursor: pointer;
				}

				dd:hover {
					background-color: #f2f2f2;
					transition: .5s all;
				}

				dd.select-this {
					color: #FFF;
					background-color: #90c31f;
				}
			}

			.form-selected {
				.edge {
					transform: rotate(180deg);
				}

				.select-group {
					display: block;
				}
			}
            
		}

	}

	.el-button--success{
		width: 140px;
		
	}


	@media screen and (max-width:768px) {

		
		.user-container {
			margin-top:50px;
			min-height: calc(100vh - 100px);
			border-top: none;
			box-sizing:border-box;
			.form {
				padding-left: 0px;
				.form-item {
					display:flex;
					margin-bottom: 10px;
				}
				.input-block{
					padding-left:0;
				}
				.form-label{
					width:80px;
					line-height: 36px;
					height: 36px;
					font-size: 12px;
				}
				.input {
					line-height: 36px;
					height: 36px;
					font-size: 12px;
					padding-left: 10px;
				}
				.form-inline {
					width: 100%;

					.input-inline {
						width: 100%;
					}
				}
				.submit {
					height:36px;
					width: 90px;
					font-size: 12px;
				}
				.input-inline {
					margin-right: 0;
				}
			}
			.main {
				width: 100%;

				.content {
					min-height:calc(100vh - 150px);
					width: 100%;
					border: none;
					padding:0;
					padding-bottom:0;
					box-sizing:border-box;
					&.rt{
						padding:0% 4%;
					}
					.head {
						 padding:15px 0;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/we/we.vue